<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <v-card-title>
                <v-icon>mdi-eye</v-icon>&nbsp;Preview
            </v-card-title>
            <v-card-text>
                <v-alert
                    dense
                    :type="mClass"
                    prominent
                >
                    <div class="text-h6">{{ mTitle }}</div>
                    <div>{{ mText }}</div>
                </v-alert>
            </v-card-text>
        </v-card>
        <v-card class="fill-height" elevation="0">
            <v-card-title>
                <v-icon>mdi-pencil</v-icon>&nbsp;Set Announcement
            </v-card-title>
            <v-card-text>
                Announcement Last updated: {{ getLastUpdatedDate }} <br /><br />
                <v-form @submit="saveAnnouncement" target="hiddenFrame">
                    <v-row>
                        <v-col cols="2">
                            <v-subheader>
                                Announcement Type
                            </v-subheader>
                        </v-col>
                        <v-col cols="10">
                            <v-select
                                v-model="mClass"
                                hint="Decides base color of the announcement box"
                                :items="mClassList"
                                persistent-hint
                                outlined
                                dense
                                @change="validateForm"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <v-subheader>
                                Announcement Title
                            </v-subheader>
                        </v-col>
                        <v-col cols="10">
                            <v-text-field
                                v-model="mTitle"
                                hint="Sets title of the message"
                                persistent-hint
                                outlined
                                dense
                                @keyup="validateForm"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            <v-subheader>
                                Announcement Text
                            </v-subheader>
                        </v-col>
                        <v-col cols="10">
                            <v-textarea
                                outlined
                                label="Sets the announcement text"
                                v-model="mText"
                                @keyup="validateForm"
                                dense
                                hint="This cannot be left blank"
                                persistent-hint
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2">
                            
                        </v-col>
                        <v-col cols="10">
                            <v-checkbox
                                v-model="mDisplay"
                                true-value="yes"
                                false-value="no"
                                label="Display announcement"
                                dense
                                @change="validateForm"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-btn
                        :disabled="!btnSubmitEnable"
                        color="success"
                        type="submit"
                        style="float: right;"
                        :loading="submitloading"
                    >
                        Submit
                    </v-btn>
                </v-form>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        messageData: {
            required: true
        },
        messageType: {
            required: true
        }
    },
    data(){
        return {
            host: location.hostname.toString(),
            mClassList: [
                {text: "info", value: "info"},
                {text: "warning", value: "warning"},
                {text: "urgent", value: "error"}
            ],
            mClass: this.messageData.class,
            mTitle: this.messageData.title,
            mText: this.messageData.text,
            mDisplay: this.messageData.display,
            btnSubmitEnable: false,
            submitloading: false,
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500
        }
    },
    computed: {
        getLastUpdatedDate(){
            if(!this.messageData.lastUpdatedDateTime){
                return this.messageData.createdDateTime
            }else {
                return this.messageData.lastUpdatedDateTime
            }
        }
    },
    methods: {
        validateForm(){
            const that = this;

            if(that.mText == null){
                that.btnSubmitEnable = false;
            }else {
                that.btnSubmitEnable = true;
            }
        },
        saveAnnouncement(){
            const that = this;
            that.submitloading = true;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?';

            const formData = new FormData();

            formData.append("mode", "adminAnnouncementsSet");
            formData.append("data", JSON.stringify({
                "type" : that.messageType,
                "class" : that.mClass,
                "title" : that.mTitle,
                "text" : that.mText,
                "display" : that.mDisplay
            }));

            //API calling
            fetch(api,{
                method: "POST",
                body: formData
            })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }else {
                        that.setSnackbar("Announcement successfully set!", "#81C784"); //green
                    }

                    that.submitloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.submitloading = false;
                })
            //End of API calling

            that.btnSubmitEnable = false;
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    /* Not using this because it runs when the form is submitted too :(
        @change is called at every form element
    updated(){
        const that = this;
        that.validateForm();
    }
    */
}
</script>